export default __webpack_public_path__ + "static/media/Elementary Robotics.6a7e3d83.png";